import React, { useState } from 'react';
import { observer } from 'src/utils/mobx-react';
import { useAppStateContext } from 'src/AppState/AppState';
import { CompetitionCombinedType } from 'src/AppState/CmsState/PromotedEventsState/PromotedEventsState';
import { PromotedEventSportState } from 'src/main/cms/PromotedEvents/promotedEventsState/PromotedEventSportState';
import { PromotedEventCompetitionSection, PromotedEventSection } from './PromotedEventSections';
import { List as MovableList } from 'react-movable';
import { ListContentWrapper } from 'src/domains/layouts/shared/cms/list/List.style';
import { PromotedEventsListState } from 'src/main/cms/PromotedEvents/promotedEventsList/promotedEventsSections/PromotedEventCompetitionSectionWrapper.state';

interface PropsType {
    competitionData: CompetitionCombinedType;
    promotedEventSportState: PromotedEventSportState;
    isDragged: boolean;
    sportId: string;
}
export const PromotedEventCompetitionSectionWrapper = observer(
    'PromotedEventCompetitionSectionWrapper',
    ({ competitionData, promotedEventSportState, sportId, isDragged }: PropsType) => {
        const {
            cmsState: { promotedEventsState },
            sdkStaff,
            trpcClient,
        } = useAppStateContext();
        const promotedEventCompetitionState = promotedEventSportState.getPromotedEventCompStateByCompId(
            competitionData.competition_id
        );
        const [state] = useState(
            () => new PromotedEventsListState(sdkStaff, trpcClient, promotedEventsState, sportId, competitionData)
        );

        if (state.isAnyEvents === false) {
            return null;
        }

        return (
            <>
                <PromotedEventCompetitionSection
                    label={state.competitionName}
                    isOpen={promotedEventCompetitionState.isOpenSection}
                    isDragged={isDragged}
                    promotedEventCompetitionState={promotedEventCompetitionState}
                    dataTest={`promoted-event-competition-${state.competitionName.toLowerCase()}`}
                />
                {promotedEventCompetitionState.isOpenSection === false ? null : (
                    <MovableList
                        values={competitionData.events_list}
                        onChange={state.handleEventsOrder}
                        renderList={({ children, props, isDragged }): React.ReactNode => (
                            <ListContentWrapper
                                {...props}
                                isDragged={isDragged}
                            >
                                {children}
                            </ListContentWrapper>
                        )}
                        renderItem={({ value, props, isDragged }): JSX.Element | null => {
                            return (
                                <div
                                    {...props}
                                    style={{ ...props.style, zIndex: 'initial' }}
                                >
                                    <PromotedEventSection
                                        key={value.id}
                                        eventData={value}
                                        getCompetitionData={promotedEventSportState.getCompetitionData}
                                        handleDeleteCompetition={promotedEventCompetitionState.handleDeleteCompetition}
                                        promotedEventsSectionState={promotedEventsState}
                                        isDragged={isDragged}
                                        dataTest={`promoted-event-${value.event_id.toString()}`}
                                    />
                                </div>
                            );
                        }}
                    />
                )}
            </>
        );
    }
);
